import { render } from "./Summary.vue?vue&type=template&id=23f17b1a&scoped=true"
import script from "./Summary.vue?vue&type=script&lang=js"
export * from "./Summary.vue?vue&type=script&lang=js"

import "./Summary.vue?vue&type=style&index=0&id=23f17b1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f17b1a"]])

export default __exports__